// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2Tlia","fileDisabled":"File_fileDisabled__2f2rL"};